import { CommentState } from "@/interfaces/comment.interface";
import { atom, RecoilState, selectorFamily } from "recoil";

export const commentState: RecoilState<CommentState> = atom({
  key: "comment",
  default: {},
});

export const childCommentState: RecoilState<CommentState> = atom({
  key: "childComment",
  default: {},
});

export const userCommentState: RecoilState<CommentState> = atom({
  key: "userComment",
  default: {},
});

export const childUserCommentState: RecoilState<CommentState> = atom({
  key: "childUserComment",
  default: {},
});

export const collectorCommentState: RecoilState<CommentState> = atom({
  key: "collectorComment",
  default: {},
});

export const childCollectorCommentState: RecoilState<CommentState> = atom({
  key: "childCollectorComment",
  default: {},
});

export const commentMergeField = selectorFamily<any, keyof CommentState>({
  key: "commentMergeField",
  get: (field) => ({ get }) => get(commentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(commentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const childCommentMergeField = selectorFamily<any, keyof CommentState>({
  key: "childCommentMergeField",
  get: (field) => ({ get }) => get(childCommentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(childCommentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const userCommentMergeField = selectorFamily<any, keyof CommentState>({
  key: "userCommentMergeField",
  get: (field) => ({ get }) => get(userCommentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(userCommentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const childUserCommentMergeField = selectorFamily<
  any,
  keyof CommentState
>({
  key: "childUserCommentMergeField",
  get: (field) => ({ get }) => get(childUserCommentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(childUserCommentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const collectorCommentMergeField = selectorFamily<
  any,
  keyof CommentState
>({
  key: "collectorCommentMergeField",
  get: (field) => ({ get }) => get(collectorCommentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(collectorCommentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const childCollectorCommentMergeField = selectorFamily<
  any,
  keyof CommentState
>({
  key: "childCollectorCommentMergeField",
  get: (field) => ({ get }) => get(childCollectorCommentState)[field],
  set: (field) => ({ set }, newValue: CommentState[typeof field]) =>
    set(childCollectorCommentState, (prevState) => ({
      ...prevState,
      [field]: { ...prevState[field], ...newValue },
    })),
});

export const batchCommentLoadingState: RecoilState<boolean> = atom({
  key: "batchCommentLoading",
  default: false,
});
